import {
  DonglesIntegrationItem,
  DroneHarmonyIntegrationItem,
  isDonglesIntegrationItem,
  isLeicaIntegrationItem,
  isXsiteIntegrationItem,
  LeicaIntegrationItem,
  XsiteIntegrationItem,
} from '../../../state/integrations-state';
import { DeleteIntegrationDialogDongleService } from './delete-integration-dialog-dongle-service';
import { DeleteIntegrationDialogLeicaService } from './delete-integration-dialog-leica-service';
import { DeleteIntegrationDialogXsiteService } from './delete-integration-dialog-xsite-service';

export const getDeleteIntegrationDialogService = (
  item:
    | XsiteIntegrationItem
    | LeicaIntegrationItem
    | DonglesIntegrationItem
    | DroneHarmonyIntegrationItem,
) => {
  if (isXsiteIntegrationItem(item)) {
    return new DeleteIntegrationDialogXsiteService(item as XsiteIntegrationItem);
  }
  if (isLeicaIntegrationItem(item)) {
    return new DeleteIntegrationDialogLeicaService(item as LeicaIntegrationItem);
  }
  if (isDonglesIntegrationItem(item)) {
    return new DeleteIntegrationDialogDongleService(item as DonglesIntegrationItem);
  }
};
